// src/pages/Product.jsx
import React from "react";
import { motion } from "framer-motion";
import digitalpen from "../assets/products/digital-pen.jpg";
import campbee from "../assets/products/campbee-crm.jpeg";

const ProductPage = () => {
  const products = [
    {
      id: 1,
      name: "Digital Pen",
      description:
        "The Digital Pen by Crack Developers revolutionizes how you take notes, brainstorm, and design. With real-time handwriting recognition and seamless cloud sync, your creativity flows naturally - no boundaries between paper and screen.",
      image: digitalpen,
      accent: "#000000",
      imageSize: "w-[400px] md:w-[450px]",
    },
    {
      id: 2,
      name: "CampBee AI Tool",
      description:
        "CampBee is your all-in-one AI assistant designed for productivity, creativity, and collaboration. From automating tasks to generating content and analyzing data - CampBee transforms how individuals and teams work smarter every day.",
      image:
        // "https://campbeeai.com/static/media/Image1.c6aefac42a04582c9f64.png",
        campbee,
      accent: "#333333",
    },
  ];

  return (
    <div className="bg-white text-gray-900 overflow-hidden">
      {/* Header Section */}
      <section className="text-center py-24 bg-black text-white">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-5xl font-semibold mb-4"
        >
          Our Products
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-lg max-w-2xl mx-auto text-gray-300"
        >
          Innovative tools crafted by Crack Developers to empower creators,
          professionals, and businesses for a smarter digital future.
        </motion.p>
      </section>

      {/* Products Section */}
      {products.map((product, index) => (
        <section
          key={product.id}
          className={`flex flex-col md:flex-row items-center justify-between py-24 px-6 md:px-20 gap-12 ${
            index % 2 === 1 ? "md:flex-row-reverse" : ""
          }`}
        >
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: index % 2 === 0 ? -60 : 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="flex-1 flex justify-center"
          >
            <div className="relative">
              <div
                className="absolute inset-0 rounded-2xl blur-3xl opacity-30"
                style={{ backgroundColor: product.accent }}
              ></div>
              <img
                src={product.image}
                alt={product.name}
                className={`relative rounded-2xl shadow-2xl object-contain ${product.imageSize || "w-[420px] md:w-[520px]"}`}
              />
            </div>
          </motion.div>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="flex-1"
          >
            <h2 className="text-4xl font-semibold mb-4">{product.name}</h2>
            <p className="text-gray-600 mb-8 leading-relaxed text-lg">
              {product.description}
            </p>
            <button className="bg-black text-white px-6 py-3 rounded-full font-medium hover:bg-gray-800 shadow-md hover:shadow-lg transition-all">
              Learn More
            </button>
          </motion.div>
        </section>
      ))}
    </div>
  );
};

export default ProductPage;
